export enum SaisineCommentType {
    'SCHOOL_TO_SCHOOL',
    'SCHOOL_TO_RECTORAT',
    'RECTORAT_TO_STUDENT'
};

export class SaisineComment {
    constructor(public id?: number,
                public label?: string,
                public dateComment?: any,
                public userEmail?: string,
                public type?: SaisineCommentType) {
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/saisine-comment/saisine-comment.model.ts